import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  card: {
    minWidth: '600px'
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
  },
  th: {
    textAlign: 'left',
    paddingBottom: theme.spacing(1),
    borderBottom: '2px solid #ddd',
    whiteSpace: 'nowrap',      // Force text to stay on one line
    overflow: 'hidden',        // Hide any overflowed content
    textOverflow: 'ellipsis',  // Add ellipsis for overflowing text
  },
  td: {
    textAlign: 'left',
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    borderBottom: '1px solid #ddd',
    whiteSpace: 'nowrap',      // Force text to stay on one line
    overflow: 'hidden',        // Hide any overflowed content
    textOverflow: 'ellipsis',  // Add ellipsis for overflowing text
  },
  avatar: {
    width: 24,
    height: 24,
    cursor: 'pointer'
  },
  keyBadge: {
    borderRadius: '8px',
    padding: '2px 4px',
    fontWeight: 'bold',
    fontSize: '0.75rem',
    display: 'inline-block',
    backgroundColor: '#e0e0e0',  // Light gray background
    color: '#333333',            // Dark gray (almost black) text
  },
  statusBadge: {
    borderRadius: '8px',
    fontSize: '0.75rem',
    padding: '2px 4px',
    fontWeight: 'bold',
    display: 'inline-block',
  },
  priorityIcon: {
    width: 18,
    height: 18,
    cursor: 'pointer' 
  },
  statusInProgress: {
    backgroundColor: '#d0e9ff',  // Light blue background
    color: '#1e90ff',            // Dodger blue text
  },
  statusBlocked: {
    backgroundColor: '#fff3cd',
    color: '#856404',
  },
  statusDraft: {
    backgroundColor: '#f8d7da',
    color: '#721c24',
  },
  link: {
    color: theme.palette.primary.main,
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  pagination: {
    marginTop: theme.spacing(1),
    display: 'flex',
    justifyContent: 'center',
  },
  jiraIcon: {
    marginRight: theme.spacing(1),
    marginBottom: theme.spacing(1),
    width: theme.spacing(3),
    height: theme.spacing(3),
  },  
}));

export default useStyles;
